const initApp = () => {
  console.log("Welcome to Static Island...")
}

export default initApp